import { Observable } from 'rxjs';
import { Auth } from 'src/app/domain/models/auth.model';
import { AuthPort } from '../../../domain/ports/auth.port';
import { UseCase } from '../../base/use-case';

export class FetchUserAttributesUsecase implements UseCase<void, Auth> {
  constructor(private authPort: AuthPort) {}

  execute(): Observable<Auth> {
    return this.authPort.fetchUserAttributes();
  }
}
